import React, { useCallback } from 'react';
import { isIOS, osVersion } from 'react-device-detect';
import styled, { keyframes } from 'styled-components';
import clsx from 'clsx';
import images, { eonImages } from '../../Theming/images';

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
`;

const StyledImage = styled.img`
  position: fixed;
  animation: ${bounce} 2s infinite;
  width: 146px;
  height: auto;
  z-index: 2;

  &.showAtBottom {
    bottom: 4px;
    left: 30px;
  }

  &.showAtTop {
    top: 8px;
    left: 5px;
  }

  &.tabletShowAtTop {
    top: 8px;
    left: 200px;
  }

  &.tabletShowAtTopIOS18 {
    top: 8px;
    left: 160px;
  }

  @media (max-width: 900px) {
    &.tabletShowAtTop {
      left: 160px;
    }
  }

  @media (min-width: 900px) {
    &.tabletShowAtTopIOS18 {
      left: 195px;
    }
  }
`;

type Image = {
  src?: any;
  showAtBottom?: boolean;
  showAtTop?: boolean;
  tabletShowAtTop?: boolean;
  tabletShowAtTopIOS18?: boolean;
};

const TapHereAnimated: React.FC = () => {
  const iosVersion = parseInt(osVersion);

  const getImage = useCallback((): Image => {
    if (isIOS) {
      // ios 18 and above
      if (iosVersion >= 18) {
        return {
          src: eonImages.tap_here_bottom_ios_18,
          showAtBottom: true,
        };
      }

      // ios 14 and below
      if (iosVersion < 15) {
        return {
          src: eonImages.tap_here_top_left,
          showAtTop: true,
        };
      }
      // default
      return {
        src: eonImages.tap_here_bottom,
        showAtBottom: true,
      };
    }

    return {
      src: eonImages.tap_here_bottom,
      showAtBottom: true,
    };
  }, [isIOS, iosVersion]);

  const {
    showAtBottom,
    showAtTop,
    tabletShowAtTop,
    src,
    tabletShowAtTopIOS18,
  } = getImage?.();
  return (
    <StyledImage
      className={clsx({
        showAtBottom,
        showAtTop,
        tabletShowAtTop,
        tabletShowAtTopIOS18,
      })}
      src={src.default}
    />
  );
};

export default TapHereAnimated;
